import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { QUOTE_QUESTIONS } from "../../AppConstants";

const rules = {
    validLicense: 'required',
    licenseState: 'required',
    currentLicenseStatus: 'required_if:validLicense,' + QUOTE_QUESTIONS.YES_NO.NO,
    licenseYears: [
        'required_if:validLicense,' + QUOTE_QUESTIONS.YES_NO.YES,
        //'required_if:currentLicenseStatus,' + QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.SUSPENDED,
        //'required_if:currentLicenseStatus,' + QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.VALID_COMMERCIAL_LICENSE,
        //'required_if:currentLicenseStatus,' + QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.VALID_CANADIAN_LICENSE,
        //'required_if:currentLicenseStatus,' + QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.EXPIRED,
        //'required_if:currentLicenseStatus,' + QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.RESTRICTED
    ],
    //driverTrainingClasses: 'required'
};

export const allFieldsValidation = (data, stateCode: string | null = null) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};